<template>
  <div v-if="visible" :class="['banner', typeClass]">
    <span v-html="message"></span>
    <button v-if="closable" class="banner-close" @click="closeBanner">&times;</button>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    message: { type: String, required: true },
    type: { type: String, default: 'info' }, // success, warning, error, info
    closable: { type: Boolean, default: false }
  },
  data() {
    return { visible: true }
  },
  computed: {
    typeClass() {
      return `banner--${this.type}`
    }
  },
  methods: {
    closeBanner() {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.banner {
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  position: relative;
  font-weight: 600;
}
.banner--success { background: #e6f9e6; color: #2e7d32; }
.banner--warning { background: #fff8e1; color: #ff9800; }
.banner--error { background: #ffebee; color: #c62828; }
.banner--info { background: #e3f2fd; color: #1565c0; }
.banner-close {
  position: absolute;
  right: 1rem;
  top: 0.75rem;
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
}
</style>
